import React from 'react';
import { fromPairs, map, isEqual, get } from 'lodash';

// local dependencies
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
import { popover } from 'modules/popover';
import { Form } from 'modules/form';
import { getLabel } from 'utils/getLabel';
import classnames from 'classnames';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { editSplashPageContent as EditSplashPageContent } from 'ui/views/widgets/editSplashPageContent';
 *
 * // render
 * <EditSplashPageContent propName='propValue'/>
 */
export const editSplashPageContent = ( props ) => {
    return (
        <div className='ui-edit-splash-page-content'>
            <div className='ui-edit-splash-page-content__header'>

                {/* title for the modal */}
                <div className='ui-edit-splash-page-content__header__title'>
                    { getLabel( props.title ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>

            <div className='ui-edit-splash-page-content__body'>
                <Form
                    fields={ fromPairs( map( props.formContent, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.itemData } // default values
                    isValid={ false }
                    onSubmit={ ( { values, isValid } ) => {
                        if( isValid ) {
                            popover.close();
                            props.onSumbitClick( values );
                        }
                    } }
                >
                    { ( { fields, values, /**isValid,*/ errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-edit-splash-page-content__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {

                                    const fieldClassName = classnames( 'ui-edit-splash-page-content__body__form__field',
                                    `ui-edit-splash-page-content__body__form__field--${ field.name }`
                                    );
                                    
                                    return (
                                        <field.view
                                            className={ fieldClassName }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            config={ field.config }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ get( props, `options.${ field.options }` ) }
                                            mask={ field.mask }
                                        />
                                    );
                                } ) }

                                {/* button actions */}
                                <div className='ui-edit-splash-page-content__body__form__actions'>
                                    { map( props.actions, action => {
                                        return (
                                            <Button
                                                key={ action.name }
                                                id= { action.name }
                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                { ...action }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='medium'
                                                className='ui-edit-splash-page-content__body__form__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ?  () => {
                                                    popover.close();
                                                    props.onCancelClick();
                                                } : null }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
            </div>
        </div>
    );
};

// set display name
editSplashPageContent.displayName = 'editSplashPageContent';

// set default props
editSplashPageContent.defaultProps = {};

// prop types
editSplashPageContent.propTypes = {};
